import posts from "../posts/index.js";
import _ from "lodash";

let routes = [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
        meta: {
            title: "ShelfSet - AI Planogram Compliance & Share of Shelf Software for Beverage Distributors",
            metaTags: [
                {
                    name: 'description',
                    content: 'ShelfSet uses AI image recognition to automate planogram compliance, share of shelf tracking, and POS display reporting for beverage distributors and retail teams.'
                }
            ]
        },
        children: [
            {
                path: '/sign-up',
                name: 'sign-up',
                component: () => import(/* webpackChunkName: "sign-up" */ '../views/SignUp.vue'),
                meta: {
                    title: "ShelfSet - Sign Up for Shelf Space App Administrator Privileges",
                    metaTags: [
                        {
                            name: "description",
                            content: "Register your company for 30 days Free access to ShelfSet shelf space app & start optimizing your operational efficiency today! AI image recognition & Reporting"
                        }
                    ]
                }
            },
        ]
    },
    {
        path: '/terms',
        name: 'terms',
        component: () => import(/* webpackChunkName: "terms" */ '../views/Terms.vue'),
        meta: {
            title: "Terms of Service — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Terms of Service for ShelfSet - Shelf Space Analysis and Retail Planogram SaaS Platform."
                }
            ]
        }
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: () => import(/* webpackChunkName: "privacy" */ '../views/Privacy.vue'),
        meta: {
            title: "Privacy — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Privacy Policy - ShelfSet Respects and Protects Your information during its collection, use and disclosure while you use our Services."
                }
            ]
        }
    },
    {
        path: '/do-not-sell',
        name: 'do-not-sell',
        component: () => import(/* webpackChunkName: "do-not-sell" */ '../views/DoNotSell.vue'),
        meta: {
            title: "Do Not Sell or Share — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "ShelfSet does not sell or share your personal information."
                }
            ]
        }
    },
    {
        path: '/about-us',
        name: 'about-us',
        component: () => import(/* webpackChunkName: "about-us" */ '../views/AboutUs.vue'),
        meta: {
            title: "ShelfSet - Retail Planogram Application for Beverage Brands",
            metaTags: [
                {
                    name: "description",
                    content: "Retail planogram application enables smarter & easier shelf space analysis through AI and automation. Based on over 50 years of industry knowledge & experience"
                }
            ]
        }
    },
    {
        path: '/blog',
        name: 'blog',
        component: () => import(/* webpackChunkName: "blog" */ '../views/Blog.vue'),
        meta: {
            title: "ShelfSet - Industry Insights on Shelf Space & Retail Planogram",
            metaTags: [
                {
                    name: "description",
                    content: "Read our latest blog posts to find out how to improve your operational efficiency and use share of shelf planogram application in beverage retail industry."
                }
            ]
        }
    },
    {
        path: '/app/:pathMatch(.*)*',
      name: 'getapp',
      component: () => import(/*webpackChunkName: "getapp" */ '../views/GetApp.vue'),
      meta: {
          title: "ShelfSet - Get the ShelfSet mobile app",
          metaTags: [
                  {
                      name: "description",
                      content: "Get the ShelfSet mobile app."
                  }
              ]
      }  
    },
    {
        path: '/planogram-compliance',
        name: 'planogram-compliance',
        component: () => import(/* webpackChunkName: "planogram-compliance" */ '../views/PlanogramCompliance.vue'),
        meta: {
            title: "Planogram Compliance Checking — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Automated planogram compliance for beverage distributors. ShelfSet uses AI image recognition to verify shelf placement, count facings, and detect deviations in minutes."
                }
            ]
        }
    },
    {
        path: '/planogram-automation-software',
        name: 'planogram-automation-software',
        component: () => import(/* webpackChunkName: "planogram-automation-software" */ '../views/PlanogramAutomationSoftware.vue'),
        meta: {
            title: "Planogram Automation Software for Beverage Retail — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "ShelfSet supports photo-based planogram compliance checking, shelf-space tracking, and POS display reporting for beverage distributors."
                }
            ]
        }
    },
    {
        path: '/retail-execution-software',
        name: 'retail-execution-software',
        component: () => import(/* webpackChunkName: "retail-execution-software" */ '../views/RetailExecutionSoftware.vue'),
        meta: {
            title: "Retail Execution Software for Beverage Brands — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "ShelfSet helps beverage teams check planogram compliance, track shelf space, and report on POS displays across stores."
                }
            ]
        }
    },
    {
        path: '/shelf-image-recognition',
        name: 'shelf-image-recognition',
        component: () => import(/* webpackChunkName: "shelf-image-recognition" */ '../views/ShelfImageRecognition.vue'),
        meta: {
            title: "Shelf Image Recognition for Beverage Retail — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Turn shelf and cooler photos into structured data with ShelfSet: brand detection, facings counts, share of shelf, and planogram compliance."
                }
            ]
        }
    },
    {
        path: '/automatic-planogram-generation',
        name: 'automatic-planogram-generation',
        component: () => import(/* webpackChunkName: "automatic-planogram-generation" */ '../views/AutomaticPlanogramGeneration.vue'),
        meta: {
            title: "Automatic Planogram Generation for Beverage Retail — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Understand automatic planogram generation, where ShelfSet fits, and when you need a dedicated planogram design tool."
                }
            ]
        }
    },
    {
        path: '/pos-fixture-reporting',
        name: 'pos-fixture-reporting',
        component: () => import(/* webpackChunkName: "pos-fixture-reporting" */ '../views/POSFixtureReporting.vue'),
        meta: {
            title: "POS Fixture Reporting for Retail Shelves — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Track and report on POS displays, coolers, and shelf fixtures with ShelfSet photo-based field verification."
                }
            ]
        }
    },
    {
        path: '/brand-logo-recognition-beverage-shelf-audits',
        name: 'brand-logo-recognition',
        component: () => import(/* webpackChunkName: "brand-logo-recognition" */ '../views/BrandLogoRecognition.vue'),
        meta: {
            title: "Brand Logo Recognition for Beverage Shelf Audits — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Automatically recognize beverage brands and logos in shelf photos to speed up audits and improve share of shelf reporting."
                }
            ]
        }
    },
    {
        path: '/compare/trax',
        name: 'compare-trax',
        component: () => import(/* webpackChunkName: "compare-trax" */ '../views/CompareTrax.vue'),
        meta: {
            title: "ShelfSet vs. Trax — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Compare ShelfSet and Trax for retail execution, planogram compliance, and distributor fit. See which platform is right for your beverage distribution team."
                }
            ]
        }
    },
    {
        path: '/compare/gospotcheck',
        name: 'compare-gospotcheck',
        component: () => import(/* webpackChunkName: "compare-gospotcheck" */ '../views/CompareGoSpotCheck.vue'),
        meta: {
            title: "ShelfSet vs. GoSpotCheck by FORM — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Compare ShelfSet and GoSpotCheck by FORM for beverage distributors. Side-by-side comparison of image recognition, shelf analytics, and field team workflows."
                }
            ]
        }
    },
    {
        path: '/compare/infilect',
        name: 'compare-infilect',
        component: () => import(/* webpackChunkName: "compare-infilect" */ '../views/CompareInfilect.vue'),
        meta: {
            title: "ShelfSet vs. Infilect — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Compare ShelfSet and Infilect for beverage distributors. Planogram compliance, share of shelf, image recognition, and field team fit side by side."
                }
            ]
        }
    },
    {
        path: '/compare/paralleldots',
        name: 'compare-paralleldots',
        component: () => import(/* webpackChunkName: "compare-paralleldots" */ '../views/CompareParallelDots.vue'),
        meta: {
            title: "ShelfSet vs. ParallelDots ShelfWatch — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Compare ShelfSet and ParallelDots ShelfWatch for beverage distributors. Shelf analytics, planogram compliance, photo capture, and SKU adaptability."
                }
            ]
        }
    },
    {
        path: '/compare/vispera',
        name: 'compare-vispera',
        component: () => import(/* webpackChunkName: "compare-vispera" */ '../views/CompareVispera.vue'),
        meta: {
            title: "ShelfSet vs. Vispera — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Compare ShelfSet and Vispera for beverage distributors. Mobile photo audits vs. fixed-camera monitoring, planogram compliance, and distributor fit."
                }
            ]
        }
    },
    {
        path: '/compare/shelfset-vs-vispera',
        name: 'compare-shelfset-vs-vispera',
        component: () => import(/* webpackChunkName: "compare-vispera" */ '../views/CompareVispera.vue'),
        meta: {
            title: "ShelfSet vs. Vispera — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Compare ShelfSet and Vispera for beverage distributors. Mobile photo audits vs. fixed-camera monitoring, planogram compliance, and distributor fit."
                }
            ]
        }
    },
    {
        path: '/compare/shelfset-vs-trax',
        name: 'compare-shelfset-vs-trax',
        component: () => import(/* webpackChunkName: "compare-trax" */ '../views/CompareTrax.vue'),
        meta: {
            title: "ShelfSet vs. Trax — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Compare ShelfSet and Trax for retail execution, planogram compliance, and distributor fit. See which platform is right for your beverage distribution team."
                }
            ]
        }
    },
    {
        path: '/compare/shelfset-vs-paralleldots',
        name: 'compare-shelfset-vs-paralleldots',
        component: () => import(/* webpackChunkName: "compare-paralleldots" */ '../views/CompareParallelDots.vue'),
        meta: {
            title: "ShelfSet vs. ParallelDots ShelfWatch — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Compare ShelfSet and ParallelDots ShelfWatch for beverage distributors. Shelf analytics, planogram compliance, photo capture, and SKU adaptability."
                }
            ]
        }
    },
    {
        path: '/compare/shelfset-vs-infilect',
        name: 'compare-shelfset-vs-infilect',
        component: () => import(/* webpackChunkName: "compare-infilect" */ '../views/CompareInfilect.vue'),
        meta: {
            title: "ShelfSet vs. Infilect — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Compare ShelfSet and Infilect for beverage distributors. Planogram compliance, share of shelf, image recognition, and field team fit side by side."
                }
            ]
        }
    },
    {
        path: '/shelf-management-software',
        name: 'shelf-management-software',
        component: () => import(/* webpackChunkName: "shelf-management-software" */ '../views/ShelfManagementSoftware.vue'),
        meta: {
            title: "Shelf Management Software for Beverage Brands — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "A practical guide to shelf management software for beverage distributors and brand teams. Compare capabilities and see how ShelfSet fits."
                }
            ]
        }
    },
    {
        path: '/what-shelfset-is',
        name: 'what-shelfset-is',
        component: () => import(/* webpackChunkName: "what-shelfset-is" */ '../views/WhatShelfSetIs.vue'),
        meta: {
            title: "What ShelfSet Is — and Is Not — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "A clear guide to where ShelfSet fits in the retail execution stack. Learn what ShelfSet does, what it does not do, and how it complements other tools."
                }
            ]
        }
    },
    {
        path: '/compare/best-planogram-automation-software',
        name: 'best-planogram-automation-software',
        component: () => import(/* webpackChunkName: "best-planogram-automation-software" */ '../views/BestPlanogramAutomationSoftware.vue'),
        meta: {
            title: "Best Planogram Automation Software in 2026 — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "A buyer's guide to planogram automation software for beverage distributors and retail execution teams. Compare approaches and see where ShelfSet fits."
                }
            ]
        }
    },
    {
        path: '/compare/best-shelf-analytics-software',
        name: 'best-shelf-analytics-software',
        component: () => import(/* webpackChunkName: "best-shelf-analytics-software" */ '../views/BestShelfAnalyticsSoftware.vue'),
        meta: {
            title: "Best Shelf Analytics Software in 2026 — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "How to choose shelf analytics software for beverage distributors and retail execution teams. Compare capture methods, capabilities, and reporting."
                }
            ]
        }
    },
    {
        path: '/compare/best-shelf-image-recognition-software',
        name: 'best-shelf-image-recognition-software',
        component: () => import(/* webpackChunkName: "best-shelf-image-recognition-software" */ '../views/BestShelfImageRecognitionSoftware.vue'),
        meta: {
            title: "Best Shelf Image Recognition Software in 2026 — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "A guide to choosing image recognition software for retail shelf audits and beverage distribution. Compare on-device, cloud, and hybrid approaches."
                }
            ]
        }
    },
    {
        path: '/compare/best-shelf-management-software-software',
        name: 'best-shelf-management-software',
        component: () => import(/* webpackChunkName: "best-shelf-management-software" */ '../views/BestShelfManagementSoftware.vue'),
        meta: {
            title: "Best Shelf Management Software in 2026 — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "How beverage distributors and retail teams can choose the right shelf management software. Compare categories and see where ShelfSet fits."
                }
            ]
        }
    },
    {
        path: '/compare/best-planogram-compliance-software',
        name: 'best-planogram-compliance-software',
        component: () => import(/* webpackChunkName: "best-planogram-compliance-software" */ '../views/BestPlanogramComplianceSoftware.vue'),
        meta: {
            title: "Best Planogram Compliance Software in 2026 — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "How to choose planogram compliance software based on capture method, deviation detail, reporting, and action workflow. See where ShelfSet fits."
                }
            ]
        }
    },
    {
        path: '/compare/best-retail-merchandising-software',
        name: 'best-retail-merchandising-software',
        component: () => import(/* webpackChunkName: "best-retail-merchandising-software" */ '../views/BestRetailMerchandisingSoftware.vue'),
        meta: {
            title: "Best Retail Merchandising Software in 2026 — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "A guide for CPG brands, beverage distributors, and retail execution teams choosing software for in-store shelf visibility and field execution."
                }
            ]
        }
    },
    {
        path: '/compare/compare-category-management-software-retail',
        name: 'category-management-software-retail',
        component: () => import(/* webpackChunkName: "category-management-software-retail" */ '../views/CategoryManagementSoftwareRetail.vue'),
        meta: {
            title: "Category Management Software for Retail — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Understand the difference between category planning, field execution, and shelf-space reporting. See where ShelfSet fits in category management."
                }
            ]
        }
    },
    {
        path: '/compare/vispera-alternatives',
        name: 'vispera-alternatives',
        component: () => import(/* webpackChunkName: "vispera-alternatives" */ '../views/VisperaAlternatives.vue'),
        meta: {
            title: "Best Vispera Alternatives for Beverage Distributors — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Compare photo-led shelf checks, fixed-camera monitoring, and focused beverage-audit workflows when evaluating alternatives to Vispera."
                }
            ]
        }
    },
    {
        path: '/compare/trax-alternatives',
        name: 'trax-alternatives',
        component: () => import(/* webpackChunkName: "trax-alternatives" */ '../views/TraxAlternatives.vue'),
        meta: {
            title: "Best Trax Alternatives for Beverage Distributors — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Compare focused shelf-space tracking with broader retail-execution platforms when evaluating alternatives to Trax."
                }
            ]
        }
    },
    {
        path: '/compare/paralleldots-alternatives',
        name: 'paralleldots-alternatives',
        component: () => import(/* webpackChunkName: "paralleldots-alternatives" */ '../views/ParallelDotsAlternatives.vue'),
        meta: {
            title: "Best ParallelDots Alternatives for Beverage Distributors — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Compare image-recognition-led retail execution tools when evaluating alternatives to ParallelDots ShelfWatch."
                }
            ]
        }
    },
    {
        path: '/compare/infilect-alternatives',
        name: 'infilect-alternatives',
        component: () => import(/* webpackChunkName: "infilect-alternatives" */ '../views/InfilectAlternatives.vue'),
        meta: {
            title: "Best Infilect Alternatives for Beverage Distributors — ShelfSet",
            metaTags: [
                {
                    name: "description",
                    content: "Compare shelf-execution tools for beverage distributors evaluating alternatives to Infilect."
                }
            ]
        }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not_found',
        component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue'),
        meta: {
            title: "Page not found — ShelfSet",
            metaTags: [
                {

                }
            ]
        }
    },
]

posts.forEach(config => {
    routes.push({
        path: `/blog/${config.path}`,
        name: `${config.path}`,
        component: () => import(`../posts/${config.component}`),
        meta: {
            title: `${_.get(config, 'meta.title', 'ShelfSet')} — Blog — ShelfSet`,
            metaTags: [
                {
                    name: 'description',
                    content: `${_.get(config, 'meta.description', '')}`
                }
            ]
        },
    })
});

export default routes;